import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        usuario:{
            logged: false
        },
        informacion: {

        },
        especiales: [],
        generalNft: [],
    },
    
    reducers: {
        setGeneralNft: (state, action) => {
            state.generalNft = [...action.payload]
        },
        setEspeciales: (state, action) => {
            state.especiales = [...action.payload]
        },
        login: (state, action) =>{
            state.usuario = {...action.payload, logged: true}
        },
        setInformacion:  (state, action) =>{
            state.informacion = {...action.payload}
        },
        exit: (state, action) => {
            state.usuario = {
                logged: false
            }
        }
    }
})
export default userSlice.reducer
export const { login, setInformacion , exit,setGeneralNft, setEspeciales } = userSlice.actions